export default __webpack_public_path__ + "static/submergido-4b8f39b738d842dc145d0f4328b430d0.webp";